module.exports = __webpack_public_path__ + "img/4.117f58f0.png";